import React, { PropsWithChildren } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';

import './index.scss';

export interface MobileFilterSheetProps {
  open: boolean;
  dismiss: () => void;
  title: string;
  className?: string;
  onClear: () => void;
  onApply: () => void;
}

export default function MobileFilterSheet({
  open,
  dismiss,
  title,
  className,
  onClear,
  onApply,
  children,
}: PropsWithChildren<MobileFilterSheetProps>) {
  return (
    <BottomSheet open={open} dismiss={dismiss} title={title} className={className}>
      {children}

      <div className="mobile-filter-sheet-footer">
        <SheetActionButton
          variant="secondary"
          className="mobile-filter-sheet-action mobile-filter-sheet-clear"
          onClick={onClear}
        >
          Limpar
        </SheetActionButton>
        <SheetActionButton
          variant="confirm"
          className="mobile-filter-sheet-action"
          onClick={onApply}
        >
          Ver resultados
        </SheetActionButton>
      </div>
    </BottomSheet>
  );
}
